exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-top-selling {\n  position: fixed;\n  float: right !important;\n  /* top: 0; */\n  right: 0;\n  /* left: 0; */\n  width: 27%;\n}\n.fixed-top-downpayment {\n  position: fixed;\n  float: right !important;\n  top: 48%;\n  /* right: 0; */\n  /* left: 0; */\n  width: 37%;\n}\n.mt-4-5 {\n  margin-top: 1.7rem !important;\n}\n.bubble-info {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36f5766a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/ProductFavorites/Show.vue
// module id = Uje/
// module chunks = 4